import { Injectable } from '@angular/core';

@Injectable()
export class WindowRefService {

  constructor() {
    window['Modernizr'].addTest('ipad', function() {
        return !!navigator.userAgent.match(/iPad/i);
    });
    
    window['Modernizr'].addTest('iphone', function() {
        return !!navigator.userAgent.match(/iPhone/i);
    });
    
    window['Modernizr'].addTest('ipod', function() {
        return !!navigator.userAgent.match(/iPod/i);
    });
    
    window['Modernizr'].addTest('appleios', function() {
        return (window['Modernizr'].ipad || window['Modernizr'].ipod || window['Modernizr'].iphone);
    });
  }

  getNativeWindow() {
    return window;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/window-ref.service.ts